module.exports = __webpack_public_path__ + "static/media/tour-2.3c9cb923.png";